var PlainText= require('./PlainText');
var RichText = require('./RichText');

module.exports = (function(){
    if(document.body.contentEditable){
        return RichText;
    }else{
        return PlainText;
    }
})();